module.exports = __webpack_public_path__ + "static/critical-mass-96ba2adea1a1e4b1b7155557f44124a0.svg";